import AppButton from '../../../../components/atoms/AppButton/AppButton'
import Layout from '../../../../layout/Layout'
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'
import { useNavigate } from 'react-router-dom'
import { Box } from '../../../../components/atoms/AppBox'
import type React from 'react'
import { useState } from 'react'
import ListCompany from '../organims/ListCompany'
import Pagination from '../../../../components/molecules/Pagination/Pagination'
import useCompanies from '../../hooks/useCompanies'
import SearchInput from 'components/molecules/SearchInput/SearchInput'

export default function ListCompanyPage() {
    const navigate = useNavigate()
    const [searchValue, setSearchValue] = useState('')
    const [currentPage, setCurrentPage] = useState(1)

    const { companies, pagination, isLoading } = useCompanies({
        search: searchValue,
        page: currentPage,
    })

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.currentTarget.value)
        setCurrentPage(1) // Reset to page 1 when searching
    }

    const changePage = (page: number) => {
        setCurrentPage(page)
    }

    return (
        <Layout>
            <HeaderPageSection title="Empresas" showGoBack={false}>
                <div>
                    <AppButton
                        title="Registrar empresa"
                        style={{
                            backgroundColor: '#568C13',
                        }}
                        onClick={() => navigate('/companies/create')}
                    />
                </div>
            </HeaderPageSection>
            <Box>
                <div className="flex flex-col gap-4 md:flex-row mb-6 w-[338px]">
                    <SearchInput
                        value={searchValue}
                        placeholder="Buscar"
                        className="justify-left w-[338px]"
                        onChange={handleSearchChange}
                        disabled={isLoading}
                    />
                </div>

                <ListCompany
                    companies={companies}
                    onCompanyClick={(company) => {
                        navigate(`/companies/${company.id}`)
                    }}
                    searchValue={searchValue}
                />
                <div className="flex justify-center">
                    <Pagination
                        totalPages={Math.ceil(
                            pagination.totalItems / pagination.itemsPerPage
                        )}
                        currentPage={pagination.page}
                        onPageChange={(page: number) => changePage(page)}
                    />
                </div>
            </Box>
        </Layout>
    )
}
